import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {PayableInvoicesActions} from '../store';
import {PayableInvoicesSelectors} from '../store/selectors';

@Injectable()
export class PayableInvoicesLoadedGuard implements CanActivate {

  constructor(private store$: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.readPayableInvoicesDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  readPayableInvoicesDone(): Observable<boolean> {

    return this.store$.pipe(
      select(PayableInvoicesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          const params = {
            'order[createdAt]': 'desc'
          };
          this.store$.dispatch(PayableInvoicesActions.ReadPayableInvoices({page: 1, params}));
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
